import { createFileRoute, useRouter } from "@tanstack/react-router";

import { ConnectTwoFaConnector } from "@pages/connect-two-fa";

export const Route = createFileRoute("/_private/connect-two-fa")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  return <ConnectTwoFaConnector onGoBack={router.history.back} />;
}
